export default "__VITE_ASSET__Do6skI6n__"